<template>
    <div class="popover" v-on:click="stopBubble">
        <slot></slot>
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class Popover extends Vue {
    name = 'popover';

    stopBubble(e) {
        e.stopPropagation();
    }
}

Vue.component('popover', Popover);
</script>
